module.exports = __webpack_public_path__ + "static/media/animweb.f916d72b.png";